import clsx from "clsx";

interface Props {
    scale?: number;
    theme?: "default" | "neutral";
}

const LoadingSpinner: React.FC<Props> = ({ scale, theme = "default" }) => (
    <div style={{ transform: `scale(${scale})` }}>
        <div
            className={clsx(
                "border-primary-800 dark:border-primary-dark-50 size-6 animate-spin rounded-[50%] border-4",
                theme === "neutral" ? "border-t-primary-50" : "border-t-primary-50 dark:border-t-primary-dark-500",
            )}
        />
    </div>
);

export default LoadingSpinner;
